import {textHandle} from 'presentation/utils/textHandle';
import React from 'react';
import {HighlightedMark} from './styles';
import {HighlightText} from './types';

export function HighlightedText({text, highlight, dataTagId}: HighlightText) {
	if (!highlight) {
		return <p data-tag-id={dataTagId}>{text}</p>;
	}

	const normalizedText = textHandle(text).removeSpecialChar().toLowerCase();
	const normalizedHighlight = textHandle(highlight).removeSpecialChar().toLowerCase();

	const startIndex = normalizedText.indexOf(normalizedHighlight);

	if (startIndex === -1) {
		return <p data-tag-id={dataTagId}>{text}</p>;
	}

	const endIndex = startIndex + normalizedHighlight.length;

	return (
		<p data-tag-id={dataTagId}>
			{text.slice(0, startIndex)}
			<HighlightedMark>{text.slice(startIndex, endIndex)}</HighlightedMark>
			{text.slice(endIndex)}
		</p>
	);
}
